import { FC } from "react";

import BaseButton from "@/components/BaseButton";

import { StyledButtonContainer } from "./Styled";

interface TaskFinishButtonProps {
    onClick: () => void;
    visible: boolean;
    padding?: string;
    loading?: boolean;
}

export const TaskFinishButton: FC<TaskFinishButtonProps> = ({
    onClick,
    visible,
    padding,
    loading = false,
}) => {
    return (
        visible && (
            <StyledButtonContainer $padding={padding}>
                <BaseButton onClick={onClick} type="primary" loading={loading}>
                    Завершити задачу
                </BaseButton>
            </StyledButtonContainer>
        )
    );
};
